import dayjs from 'dayjs'
import _ from 'lodash'

// One chart row per site, with a field per category key.
export const getChartRows = (dataset, keys = []) =>
  (dataset ?? []).map((row) => ({
    site: row.keyDoc ? row.keyDoc.name : row.key,
    ...Object.fromEntries(keys.map(({ key }) => [key, getValue(row.data, key)]))
  }))

// One chart row per month (`month`, its label), with a field per dataset row named by `fieldOf`.
export const getMonthRows = (dataset, monthKeys, labels, fieldOf) =>
  labels.map((month, index) => ({
    month,
    ...Object.fromEntries(
      (dataset ?? []).map((row, rowIndex) => [
        fieldOf(row, rowIndex),
        getValue(row.data, monthKeys[index].key)
      ])
    )
  }))

const getValue = (data, key) => {
  const row = _.find(data, { key })
  return row ? row.value : 0
}

export const getTableData = (dataset = [], keys = [], maxNameLength) => {
  return dataset.map((row) => {
    const values = keys.map(({ key }) => getValue(row.data, key))
    let keyName = row.keyDoc ? row.keyDoc.name : row.key
    if (maxNameLength) {
      keyName = _.truncate(keyName, { length: maxNameLength })
    }
    return [keyName, ...values]
  })
}

export const getMonths = (from, to) => {
  const months = Math.ceil(to.diff(from, 'month'))
  return _.range(0, months).map((d) => dayjs(from).add(d + 1, 'months'))
}

export const getTotalByKey = (data, keys) => {
  return keys.map((key) => {
    return {
      key,
      value: _.chain(data)
        .map('data')
        .flatten()
        .filter({ key })
        .sumBy('value')
        .value()
    }
  })
}

export const orderByTotal = (data, sort) => {
  return _.orderBy(data, (row) => {
    const total = _.sumBy(row.data, 'value')
    const sortOrder = sort.order === 'asc' ? 1 : -1
    return (sortOrder * getValue(row.data, sort.key)) / total
  })
}
